import { LandingMultiSport } from '@sorare/core/src/components/landing/LandingMultiSport';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { metadatas } from '@sorare/core/src/lib/seo/common';

export const Landing = () => {
  useTitleAndDescription(
    metadatas.landing.title,
    metadatas.landing.description
  );

  return <LandingMultiSport />;
};
